// Mock data for the admin dashboard
export const studentsData = [
  {
    id: 1,
    name: "John Doe",
    email: "john.doe@university.edu",
    department: "Computer Science",
    year: 4,
    gpa: 3.8,
    interviewsCompleted: 15,
    averageScore: 85,
    topicStrengths: ["Data Structures", "Algorithms"],
    topicWeaknesses: ["System Design", "Database Management"],
    jobReadyStatus: "Job Ready",
    readinessScore: 85,
    // LMS Data
    coursesEnrolled: 8,
    coursesCompleted: 6,
    lmsEngagementScore: 92,
    totalStudyHours: 240,
    // Assessment Data
    assessmentsTaken: 32,
    assessmentAverage: 87,
    lastAssessmentDate: "2025-09-08",
    // Coding Practice Data
    codingProblemsAttempted: 145,
    codingProblemsSolved: 128,
    codingStreakDays: 23,
    preferredLanguages: ["Python", "JavaScript"],
    difficultyLevel: "Advanced",
    // AI Interview Data
    aiInterviewsCompleted: 8,
    aiInterviewAverage: 82,
    communicationScore: 85,
    technicalScore: 88,
    confidenceScore: 79
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane.smith@university.edu",
    department: "Computer Science",
    year: 4,
    gpa: 3.9,
    interviewsCompleted: 20,
    averageScore: 92,
    topicStrengths: ["System Design", "Machine Learning"],
    topicWeaknesses: ["Dynamic Programming"],
    jobReadyStatus: "Job Ready",
    readinessScore: 92,
    // LMS Data
    coursesEnrolled: 10,
    coursesCompleted: 9,
    lmsEngagementScore: 96,
    totalStudyHours: 320,
    // Assessment Data
    assessmentsTaken: 38,
    assessmentAverage: 94,
    lastAssessmentDate: "2025-09-09",
    // Coding Practice Data
    codingProblemsAttempted: 198,
    codingProblemsSolved: 185,
    codingStreakDays: 45,
    preferredLanguages: ["Java", "Python", "C++"],
    difficultyLevel: "Expert",
    // AI Interview Data
    aiInterviewsCompleted: 12,
    aiInterviewAverage: 91,
    communicationScore: 93,
    technicalScore: 95,
    confidenceScore: 88
  },
  {
    id: 3,
    name: "Mike Johnson",
    email: "mike.johnson@university.edu",
    department: "Electronics",
    year: 3,
    gpa: 3.2,
    interviewsCompleted: 8,
    averageScore: 68,
    topicStrengths: ["Digital Systems"],
    topicWeaknesses: ["Communication Skills", "Problem Solving"],
    jobReadyStatus: "Needs Improvement",
    readinessScore: 45,
    // LMS Data
    coursesEnrolled: 6,
    coursesCompleted: 3,
    lmsEngagementScore: 65,
    totalStudyHours: 120,
    // Assessment Data
    assessmentsTaken: 18,
    assessmentAverage: 72,
    lastAssessmentDate: "2025-09-05",
    // Coding Practice Data
    codingProblemsAttempted: 68,
    codingProblemsSolved: 42,
    codingStreakDays: 5,
    preferredLanguages: ["C", "Python"],
    difficultyLevel: "Intermediate",
    // AI Interview Data
    aiInterviewsCompleted: 4,
    aiInterviewAverage: 58,
    communicationScore: 52,
    technicalScore: 68,
    confidenceScore: 55
  },
  {
    id: 4,
    name: "Sarah Wilson",
    email: "sarah.wilson@university.edu",
    department: "Computer Science",
    year: 4,
    gpa: 3.7,
    interviewsCompleted: 12,
    averageScore: 78,
    topicStrengths: ["Web Development", "Database Management"],
    topicWeaknesses: ["System Design", "Algorithms"],
    jobReadyStatus: "Job Ready",
    readinessScore: 78,
    // LMS Data
    coursesEnrolled: 9,
    coursesCompleted: 7,
    lmsEngagementScore: 88,
    totalStudyHours: 280,
    // Assessment Data
    assessmentsTaken: 29,
    assessmentAverage: 81,
    lastAssessmentDate: "2025-09-07",
    // Coding Practice Data
    codingProblemsAttempted: 112,
    codingProblemsSolved: 89,
    codingStreakDays: 18,
    preferredLanguages: ["JavaScript", "Python"],
    difficultyLevel: "Advanced",
    // AI Interview Data
    aiInterviewsCompleted: 7,
    aiInterviewAverage: 76,
    communicationScore: 82,
    technicalScore: 74,
    confidenceScore: 73
  },
  {
    id: 5,
    name: "Alex Brown",
    email: "alex.brown@university.edu",
    department: "Information Technology",
    year: 4,
    gpa: 3.5,
    interviewsCompleted: 18,
    averageScore: 88,
    topicStrengths: ["Network Security", "Cloud Computing"],
    topicWeaknesses: ["Data Structures"],
    jobReadyStatus: "Job Ready",
    readinessScore: 88,
    // LMS Data
    coursesEnrolled: 8,
    coursesCompleted: 8,
    lmsEngagementScore: 94,
    totalStudyHours: 305,
    // Assessment Data
    assessmentsTaken: 35,
    assessmentAverage: 89,
    lastAssessmentDate: "2025-09-08",
    // Coding Practice Data
    codingProblemsAttempted: 156,
    codingProblemsSolved: 142,
    codingStreakDays: 32,
    preferredLanguages: ["Java", "Go"],
    difficultyLevel: "Advanced",
    // AI Interview Data
    aiInterviewsCompleted: 10,
    aiInterviewAverage: 86,
    communicationScore: 84,
    technicalScore: 92,
    confidenceScore: 82
  },
  {
    id: 6,
    name: "Emily Davis",
    email: "emily.davis@university.edu",
    department: "Computer Science",
    year: 3,
    gpa: 3.1,
    interviewsCompleted: 5,
    averageScore: 55,
    topicStrengths: ["Basic Programming"],
    topicWeaknesses: ["Data Structures", "Algorithms", "System Design", "Communication Skills"],
    jobReadyStatus: "Needs Improvement",
    readinessScore: 35,
    // LMS Data
    coursesEnrolled: 5,
    coursesCompleted: 2,
    lmsEngagementScore: 48,
    totalStudyHours: 85,
    // Assessment Data
    assessmentsTaken: 12,
    assessmentAverage: 58,
    lastAssessmentDate: "2025-09-03",
    // Coding Practice Data
    codingProblemsAttempted: 35,
    codingProblemsSolved: 18,
    codingStreakDays: 2,
    preferredLanguages: ["Python"],
    difficultyLevel: "Beginner",
    // AI Interview Data
    aiInterviewsCompleted: 2,
    aiInterviewAverage: 45,
    communicationScore: 48,
    technicalScore: 42,
    confidenceScore: 45
  }
];

export const departmentStats = {
  "Computer Science": { students: 120, jobReady: 85, averageReadinessScore: 78 },
  "Electronics": { students: 80, jobReady: 45, averageReadinessScore: 65 },
  "Information Technology": { students: 100, jobReady: 70, averageReadinessScore: 72 },
  "Mechanical": { students: 90, jobReady: 50, averageReadinessScore: 68 }
};

export const topicAnalysis = {
  "Data Structures": { strongStudents: 45, weakStudents: 35, averageScore: 72 },
  "Algorithms": { strongStudents: 40, weakStudents: 40, averageScore: 70 },
  "System Design": { strongStudents: 25, weakStudents: 55, averageScore: 65 },
  "Problem Solving": { strongStudents: 50, weakStudents: 30, averageScore: 78 },
  "Web Development": { strongStudents: 42, weakStudents: 18, averageScore: 80 },
  "Machine Learning": { strongStudents: 20, weakStudents: 15, averageScore: 82 },
  "Network Security": { strongStudents: 25, weakStudents: 20, averageScore: 76 },
  "Cloud Computing": { strongStudents: 30, weakStudents: 25, averageScore: 74 }
};

export const jobReadinessTrends = [
  { month: "Jan", jobReady: 12, totalAssessed: 45 },
  { month: "Feb", jobReady: 18, totalAssessed: 52 },
  { month: "Mar", jobReady: 25, totalAssessed: 68 },
  { month: "Apr", jobReady: 32, totalAssessed: 75 },
  { month: "May", jobReady: 28, totalAssessed: 60 },
  { month: "Jun", jobReady: 35, totalAssessed: 80 },
  { month: "Jul", jobReady: 42, totalAssessed: 85 },
  { month: "Aug", jobReady: 38, totalAssessed: 78 },
  { month: "Sep", jobReady: 45, totalAssessed: 90 }
];

export const skillDevelopmentPrograms = [
  { program: "Technical Skills Bootcamp", enrolled: 25, completed: 18, averageImprovement: 35 },
  { program: "Communication Skills Workshop", enrolled: 30, completed: 22, averageImprovement: 28 },
  { program: "Interview Preparation", enrolled: 40, completed: 35, averageImprovement: 42 },
  { program: "System Design Masterclass", enrolled: 15, completed: 12, averageImprovement: 38 },
  { program: "Soft Skills Development", enrolled: 35, completed: 28, averageImprovement: 32 },
  { program: "Industry Mentorship", enrolled: 20, completed: 18, averageImprovement: 45 }
];

export const performanceMetrics = {
  totalStudents: 390,
  jobReadyStudents: 250,
  averageReadinessScore: 72,
  averageInterviewScore: 75,
  topPerformers: 45,
  needsAttention: 65
};

// LMS Analytics
export const lmsAnalytics = {
  totalCourses: 125,
  activeLearners: 340,
  completionRate: 78,
  averageEngagementScore: 82,
  totalStudyHours: 8950,
  topCourses: [
    { name: "Data Structures & Algorithms", enrollments: 156, completion: 84 },
    { name: "System Design Fundamentals", enrollments: 142, completion: 76 },
    { name: "Web Development Bootcamp", enrollments: 134, completion: 88 },
    { name: "Machine Learning Basics", enrollments: 98, completion: 72 },
    { name: "Database Management", enrollments: 89, completion: 82 }
  ]
};

// Assessment Platform Analytics
export const assessmentAnalytics = {
  totalAssessments: 1250,
  averageScore: 76,
  passRate: 82,
  improvementRate: 15,
  categoryBreakdown: [
    { category: "Technical Skills", average: 78, attempts: 425 },
    { category: "Problem Solving", average: 74, attempts: 380 },
    { category: "Communication", average: 71, attempts: 245 },
    { category: "System Design", average: 69, attempts: 200 }
  ],
  weeklyTrends: [
    { week: "Week 1", assessments: 142, average: 72 },
    { week: "Week 2", assessments: 156, average: 74 },
    { week: "Week 3", assessments: 168, average: 76 },
    { week: "Week 4", assessments: 189, average: 78 }
  ]
};

// Coding Practice Platform Analytics
export const codingAnalytics = {
  totalProblems: 2450,
  problemsSolved: 1890,
  averageSolveRate: 77,
  activeCoders: 325,
  languagePopularity: [
    { language: "Python", usage: 45, problems: 892 },
    { language: "JavaScript", usage: 28, problems: 567 },
    { language: "Java", usage: 18, problems: 445 },
    { language: "C++", usage: 12, problems: 234 },
    { language: "Go", usage: 8, problems: 156 }
  ],
  difficultyDistribution: [
    { level: "Beginner", solved: 680, total: 820, percentage: 83 },
    { level: "Intermediate", solved: 545, total: 750, percentage: 73 },
    { level: "Advanced", solved: 420, total: 580, percentage: 72 },
    { level: "Expert", solved: 245, total: 300, percentage: 82 }
  ],
  streakData: [
    { range: "1-7 days", students: 85 },
    { range: "8-21 days", students: 142 },
    { range: "22-45 days", students: 68 },
    { range: "45+ days", students: 30 }
  ]
};

// AI Interview Analytics
export const aiInterviewAnalytics = {
  totalInterviews: 890,
  averageScore: 74,
  passRate: 68,
  improvementRate: 22,
  skillBreakdown: [
    { skill: "Technical Knowledge", average: 78, weight: 40 },
    { skill: "Communication", average: 72, weight: 30 },
    { skill: "Problem Solving", average: 76, weight: 20 },
    { skill: "Confidence", average: 69, weight: 10 }
  ],
  interviewTypes: [
    { type: "Technical Screening", count: 245, average: 76 },
    { type: "System Design", count: 189, average: 71 },
    { type: "Behavioral", count: 234, average: 74 },
    { type: "Coding Challenge", count: 222, average: 78 }
  ],
  monthlyProgress: [
    { month: "May", interviews: 98, average: 69 },
    { month: "Jun", interviews: 112, average: 71 },
    { month: "Jul", interviews: 134, average: 74 },
    { month: "Aug", interviews: 145, average: 76 },
    { month: "Sep", interviews: 156, average: 78 }
  ]
};

// Platform Integration Metrics
export const integrationMetrics = {
  crossPlatformEngagement: 85,
  dataSync: 98,
  userJourney: [
    { stage: "LMS Enrollment", users: 390, retention: 92 },
    { stage: "Assessment Started", users: 358, retention: 88 },
    { stage: "Coding Practice", users: 315, retention: 82 },
    { stage: "AI Interview", users: 258, retention: 75 },
    { stage: "Job Ready", users: 195, retention: 68 }
  ],
  platformUsage: [
    { platform: "LMS", dailyActive: 285, weeklyActive: 340 },
    { platform: "Assessment", dailyActive: 195, weeklyActive: 289 },
    { platform: "Coding Practice", dailyActive: 235, weeklyActive: 325 },
    { platform: "AI Interview", dailyActive: 89, weeklyActive: 178 }
  ]
};

export const yearWisePerformance = [
  { year: 1, averageReadiness: 45, averageInterview: 40, totalStudents: 120 },
  { year: 2, averageReadiness: 60, averageInterview: 55, totalStudents: 110 },
  { year: 3, averageReadiness: 75, averageInterview: 70, totalStudents: 100 },
  { year: 4, averageReadiness: 85, averageInterview: 80, totalStudents: 60 }
];

// HOD Email to Branch and Year Mapping
// These users will only see their respective branches/years in filters
export const hodBranchMapping = {
  'hod_aids@piemr.edu.in': {
    name: 'Dr. Dipti Chouhan',
    branches: ['Artificial Intelligence And Data Science', 'CSE (IOT And Cyber Security Including Block Chain Technology)'],
    years: null // null means all years
  },
  'hod_me@piemr.edu.in': {
    name: 'Dr. Lokesh Boriwal',
    branches: ['Automation And Robotics', 'Mechanical Engineering'],
    years: null
  },
  'hod_ce@piemr.edu.in': {
    name: 'Dr. Raksha Parulkar',
    branches: ['Civil Engineering'],
    years: null
  },
  'hod_ceca@piemr.edu.in': {
    name: 'Dr. Monica Dagliya',
    branches: ['Civil Engineering with Computer Application'],
    years: null
  },
  'hod_cs@piemr.edu.in': {
    name: 'Dr. Piyush Choudhary',
    branches: ['Computer Science And Engineering'],
    years: null
  },
  'hod_ee@piemr.edu.in': {
    name: 'Dr. Dipali Sarvate',
    branches: ['Electrical Engineering', 'Electrical and Power Engineering'],
    years: null
  },
  'hod_ec@piemr.edu.in': {
    name: 'Dr. Mahendra Singh Thakur',
    branches: ['Electronics And Communications Engineering'],
    years: null
  },
  'hod_ash@piemr.edu.in': {
    name: 'ASH Coordinator',
    branches: null, // null means all branches
    years: ['1'] // Only Year 1
  }
};

// Helper function to get allowed branches for a user
export const getAllowedBranches = (userEmail) => {
  if (!userEmail) return null; // No email means show all branches (admin)
  
  const hodInfo = hodBranchMapping[userEmail.toLowerCase()];
  if (hodInfo) {
    return hodInfo.branches; // Return specific branches for HOD (null means all)
  }
  
  return null; // Not a HOD, show all branches (regular admin)
};

// Helper function to get allowed years for a user
export const getAllowedYears = (userEmail) => {
  if (!userEmail) return null; // No email means show all years (admin)
  
  const hodInfo = hodBranchMapping[userEmail.toLowerCase()];
  if (hodInfo) {
    return hodInfo.years; // Return specific years for HOD (null means all)
  }
  
  return null; // Not a HOD, show all years (regular admin)
};

// Helper function to check if user is HOD
export const isHOD = (userEmail) => {
  if (!userEmail) return false;
  return hodBranchMapping.hasOwnProperty(userEmail.toLowerCase());
};

// Helper function to get HOD info
export const getHODInfo = (userEmail) => {
  if (!userEmail) return null;
  return hodBranchMapping[userEmail.toLowerCase()] || null;
};
